<a href="https://wa.me/+4915225964039" class="redButton" target="_blank" style="float: right;" type="button" mat-raised-button color="warn" (click)="buttonClicked('personal_guidance')">Whatsapp for Personal Guidance</a>
<br><br>
<a href="https://forms.gle/Hph2KuJTYvcpbK1T8" target="_blank" style="float: right;" type="button" mat-button>We Appreciate Feedback</a>

<br><br>
<mat-label>
  1. Share with your friends and receive a free CV and LOM check :
  <share-buttons [theme]="'modern-dark'"
  [include]="['facebook','twitter','linkedin','whatsapp']"
  [show]="5"
  [url]="'https://squickr-964bc.web.app/'"
  [description]="'Study in Germany with Squickr'"
  (opened)="shareClicked('shared', $event)"
  [autoSetMeta]="false"
  ></share-buttons>
</mat-label>

<br><br>
<mat-label>
  2. Do you have more questions? Join our community :
</mat-label>
<a href="https://t.me/joinchat/NH9dUn2Wr-g2NDAy" target="_blank" mat-button (click)="communityClicked('Community', 'Telegram')">Telegram</a>
<a href="https://chat.whatsapp.com/E7yWAcCZJ5rJrKHyhUi9Ny" target="_blank" (click)="communityClicked('Community', 'Whatsapp')" mat-button>Whatsapp</a>

<br><br>
<mat-label>
  3. Select your courses and universities
</mat-label>
<a href="https://university-finder.surge.sh/" target="_blank" (click)="buttonClicked('Select Course')" mat-button>Select</a>

<hr>
